import React from "react";
import call from "../../assets/call.png";
import GetInTouch from "../Home/GetInTouch/GetInTouch";

const RefundPolicy = () => {
  return (
    <>
      <div class="hero for-inner">
        <div class="container">
          <div class="hero-grid inner">
            <div class="hero-w-width on-inner">
              <h1 class="display-1">
                Refund <span class="gray-text-color">Policy</span>
              </h1>
            </div>
          </div>
        </div>
      </div>
      <div class="section legal">
        <div class="container">
          <div>
            <div class="leagl-wrapper">
              <div
                data-w-id="eb6b77d4-5c7b-d30c-b6da-7c7144717a91"
                class="legal-wrapper"
              >
                <p>Last updated: 17 Oct 2024</p>
                <div class="margin-30px">
                  <p class="terms-paragraph">
                    This Refund Policy outlines the rules and conditions under
                    which refunds may be requested and processed for services
                    provided by{" "}
                    <strong>
                      ORE Migration Services PTY Ltd T/A{" "}
                      <strong>Win Migration Group</strong>
                    </strong>
                    ("<strong>Win Migration Group</strong>," "we," "our," or
                    "us"). This policy applies to all services, including but
                    not limited to, migration consulting, visa applications,
                    admissions to colleges/universities, and health insurance
                    facilitated through third-party providers. All fees,
                    charges, and refunds are administered in accordance with
                    applicable Australian law and contractual agreements.
                  </p>
                </div>
                <div class="margin-30px">
                  <h4 class="heading-3">
                    <strong>1. Policy Statement</strong>
                    <br />
                  </h4>
                </div>
                <div class="margin-30px">
                  <div class="rich-text-block-2 w-richtext">
                    <p class="terms-paragraph">
                      This Refund Policy is designed to be fair to clients who
                      submit valid refund requests while protecting{" "}
                      <strong>
                        <strong>Win Migration Group</strong>
                      </strong>{" "}
                      from economic losses resulting from inappropriate refund
                      claims. This policy governs the refunds related to all
                      services provided, including visa applications, health
                      insurance policies, education admissions, and others.
                      Refunds will not be issued for early service withdrawal.
                      Clients are made aware of all fees and terms prior to
                      entering a service agreement, and by engaging our
                      services, they acknowledge acceptance of these terms.
                    </p>
                  </div>
                </div>
                <div class="margin-30px">
                  <h4>
                    <strong class="bold-text">2. Fees and Charges</strong>
                    <br />
                  </h4>
                </div>
                <div class="margin-30px">
                  <div class="rich-text-block-2 w-richtext">
                    <ul role="list">
                      <li class="terms-list-item">
                        Service Agreement: All fees are clearly communicated to
                        the client before entering a service agreement. Fees
                        charged reflect the scope of services provided, and
                        clients receive an invoice at the time of payment.
                      </li>
                      <li class="terms-list-item">
                        Non-refundable Service Charges: Once a client agrees to
                        engage our services and makes the payment, these service
                        charges are non-refundable. This includes any change of
                        mind or early termination of services.
                      </li>
                      <li class="terms-list-item">
                        Third-party Fees: The service charge paid to{" "}
                        <strong>Win Migration Group</strong> only covers our
                        services and does not include additional fees charged by
                        external authorities (e.g., visa application fees,
                        assessing fees, or insurance policy fees). Clients are
                        responsible for these external payments, and no refunds
                        will be issued by <strong>Win Migration Group</strong>{" "}
                        for fees paid to third-party authorities in the event of
                        visa refusal, application rejection, or any other
                        outcome
                      </li>
                    </ul>
                  </div>
                </div>
                <div class="margin-30px">
                  <h4>
                    <strong class="bold-text">
                      3. No Refunds for Service Withdrawal
                    </strong>
                    <br />
                  </h4>
                </div>
                <div class="margin-30px">
                  <div class="rich-text-block-2 w-richtext">
                    <p class="terms-paragraph">
                      If, at any point, a client decides to discontinue the
                      services of <strong>Win Migration Group</strong>, they
                      will not be eligible for a refund. Additionally, no
                      refunds will be transferred to a third party (e.g., friend
                      or family member) if the original client withdraws their
                      application for any reason.
                    </p>
                    <p class="terms-paragraph">
                      Refunds or adjustments will not be made if the client
                      decides to switch to another service or process with{" "}
                      <strong>Win Migration Group</strong>, or if they choose to
                      migrate to a different country. Any such adjustments, if
                      applicable, will be made at the sole discretion of{" "}
                      <strong>Win Migration Group</strong>.
                    </p>
                  </div>
                </div>
                <div class="margin-30px">
                  <h4>
                    <strong class="bold-text">
                      4. Conditions for No Refunds
                    </strong>
                    <br />
                  </h4>
                </div>
                <div class="margin-30px">
                  <div class="rich-text-block-2 w-richtext">
                    <p class="terms-paragraph">
                      <strong>Win Migration Group</strong> will not provide
                      refunds in the following circumstances:
                    </p>
                    <ul role="list" class="list">
                      <li class="terms-list-item">
                        Changes in Immigration Rules: If immigration laws or
                        policies change after a service agreement is signed,
                        leading to the client's ineligibility, no refund will be
                        provided.
                      </li>
                      <li class="terms-list-item">
                        Failure to Comply with Requirements: If the client fails
                        to attend visa interviews, provide requested
                        documentation, or submit accurate information during the
                        process, no refund will be provided.
                      </li>
                      <li class="terms-list-item">
                        Fraudulent or Misleading Information: If the client
                        provides fraudulent or inaccurate documentation or
                        conceals previous visa refusals, no refund will be
                        provided.
                      </li>
                      <li class="terms-list-item">
                        Refusal by Authorities: If the application is refused by
                        assessing authorities, embassies, or immigration
                        departments, <strong>Win Migration Group</strong> is not
                        liable for refunds.
                      </li>
                    </ul>
                  </div>
                </div>

                <div class="margin-30px">
                  <h4>
                    <strong class="bold-text">5. No Chargebacks Policy</strong>
                    <br />
                  </h4>
                </div>
                <div class="margin-30px">
                  <div class="rich-text-block-2 w-richtext">
                    <p class="terms-paragraph">
                      <strong>Win Migration Group</strong> has a zero-tolerance
                      policy for chargebacks. Clients who dispute a valid
                      payment will be permanently blacklisted from using our
                      services, and any unpaid fees will be sent to collections.
                    </p>
                    <p class="terms-paragraph">
                      Clients who make payments via credit card or net banking
                      agree not to dispute or request a chargeback without first
                      contacting <strong>Win Migration Group</strong> to resolve
                      any issues. If a chargeback is requested,{" "}
                      <strong>Win Migration Group</strong> reserves the right to
                      dispute it with the payment provider and pursue legal
                      action if necessary.
                    </p>
                  </div>
                </div>
                <div class="margin-30px">
                  <h4>
                    <strong class="bold-text">
                      6. Process for Claiming Refunds
                    </strong>
                    <br />
                  </h4>
                </div>
                <div class="margin-30px">
                  <div class="rich-text-block-2 w-richtext">
                    <p>
                      To request a refund, clients must submit a formal Refund
                      Application in writing, accompanied by supporting
                      documents where appropriate. Refund claims must be made in
                      compliance with the following procedure:
                    </p>
                    <ul role="list" class="list">
                      <li class="terms-list-item">
                        1. Complete the Refund Application Form, detailing the
                        reason for the refund request.
                      </li>
                      <li class="terms-list-item">
                        2. Submit the form via email to
                        reception@winmigrationgroup.com.
                      </li>
                      <li class="terms-list-item">
                        3. Ensure that all required documents and signatures are
                        included; mismatched signatures from the original
                        service agreement will invalidate the refund claim.
                      </li>
                      <li class="terms-list-item">
                        Refunds will only be processed in the original payment
                        currency, and any outstanding debts to{" "}
                        <strong>Win Migration Group</strong> must be cleared
                        before the refund is issued.
                      </li>
                    </ul>
                  </div>
                </div>
                <div class="margin-30px">
                  <h4>
                    <strong class="bold-text">7. Case-Specific Refunds</strong>
                    <br />
                  </h4>
                </div>
                <div class="margin-30px">
                  <div class="rich-text-block-2 w-richtext">
                    <strong>1. Paid Consultations</strong>
                    <p>
                      All fees paid for consultations (in-person or telephonic)
                      are non-refundable once the consultation has taken place.
                      Consultation fees may be adjusted toward further migration
                      or admission services if a service agreement is signed.
                    </p>
                    <strong>2. Health Insurance</strong>
                    <p>
                      Once health insurance fees have been paid, no refunds will
                      be issued by <strong>Win Migration Group</strong>. Clients
                      are advised to contact the insurance provider directly for
                      cancellations or refunds, as they are subject to the
                      provider’s terms and conditions.
                    </p>
                    <strong>3. PTE or IELTS Coaching</strong>
                    <p>
                      No refunds will be provided for PTE, NAATI CCL, or IELTS
                      courses after they have commenced or once payment has been
                      made. The course duration will be based on the selection
                      made at the time of enrolment.
                    </p>
                  </div>
                </div>
                <div class="margin-30px">
                  <h4>
                    <strong class="bold-text">
                      8. Responsibilities and Decision Making
                    </strong>
                    <br />
                  </h4>
                </div>
                <div class="margin-30px">
                  <div class="rich-text-block-2 w-richtext">
                    <p>
                      The Accounts Manager is responsible for processing refund
                      claims, which are then reviewed by the Directors of{" "}
                      <strong>Win Migration Group</strong>. The final decision
                      regarding refunds rests with the Director, and all
                      decisions are final.
                    </p>
                  </div>
                </div>
                <div class="margin-30px">
                  <h4>
                    <strong class="bold-text">
                      9. Confidentiality and Privacy
                    </strong>
                    <br />
                  </h4>
                </div>
                <div class="margin-30px">
                  <div class="rich-text-block-2 w-richtext">
                    <p>
                      <strong>Win Migration Group</strong> is committed to
                      maintaining the confidentiality of client information. All
                      personal data is handled in accordance with the Privacy
                      Act, and client details will not be shared or used outside
                      of the primary purpose for which they were collected
                      unless authorized by law.
                    </p>
                  </div>
                </div>
                <div class="margin-30px">
                  <h4>
                    <strong class="bold-text">Disclaimer</strong>
                    <br />
                  </h4>
                </div>
                <div class="margin-30px">
                  <div class="rich-text-block-2 w-richtext">
                    <p>
                      Prices for services provided in Australia are quoted in
                      Australian Dollars (AUD).{" "}
                      <strong>Win Migration Group</strong> is not liable for any
                      loss or damage arising from payment processing issues or
                      transaction declines due to cardholder limits or errors by
                      the acquiring bank.
                    </p>
                  </div>
                </div>
                <div class="margin-30px">
                  <div class="rich-text-block-2 w-richtext">
                    <p>
                      ORE Migration Services PTY Ltd T/A Win Migration Group ABN
                      11 640 885 623
                    </p>
                    <p>
                      Email:
                      <a href="mailto:contact@winmigrationgroup.com">
                        contact@winmigrationgroup.com
                      </a>
                    </p>
                    <p>Last updated: 17 Oct 2024</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <GetInTouch />
    </>
  );
};

export default RefundPolicy;
